import React from 'react';
import NFLteams from './components/nflTeams'
import './App.css';

function App() {
  
  return (
    <div className="App">
      <NFLteams/>
    </div>
  );
}

export default App;
